const round2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;

export const calculateAdjustedPrice = (
  basePrice,
  adjustmentType = 'NONE',
  adjustmentValue = 0,
  adjustmentMode = 'FLAT'
) => {
  const base = Number(basePrice || 0);
  const value = Number(adjustmentValue || 0);

  if (adjustmentType === 'NONE') return round2(base);

  if (adjustmentType === 'MANUAL_OVERRIDE') {
    const final = round2(value);
    if (final < 0) throw new Error('Final price cannot be negative');
    return final;
  }

  if (!['DISCOUNT', 'SURCHARGE'].includes(adjustmentType)) {
    throw new Error('Invalid adjustmentType');
  }
  if (!['FLAT', 'PERCENTAGE'].includes(adjustmentMode)) {
    throw new Error('Invalid adjustmentMode');
  }

  let delta = adjustmentMode === 'FLAT' ? value : (base * value) / 100;
  let final = adjustmentType === 'DISCOUNT' ? Math.max(0, base - delta) : base + delta;
  return round2(final);
};

export const calculateOrderTotal = (items = [], orderAdjustment = {}) => {
  const subtotalAmount = round2(
    items.reduce((sum, item) => sum + Number(item.finalUnitPrice || 0) * Number(item.quantity || 0), 0)
  );

  const totalAmount = calculateAdjustedPrice(
    subtotalAmount,
    orderAdjustment.adjustmentType || 'NONE',
    orderAdjustment.adjustmentValue || 0,
    orderAdjustment.adjustmentMode || 'FLAT'
  );

  return { subtotalAmount, totalAmount };
};
